
export const Colors = {
  GrayDark: '#373739',
  GrayMedium: '#aaaaaa',
  GrayMediumLight: '#cdcdcd',
  GrayLight: '#dddddd',
  GrayVeryLight: '#eeeeee',
  GrayLightStandard: '#e6e7e8',
  GoldDark: '#C7B087',
  Gold: '#D3C097',
  GoldLight: '#E0CFA9',
  White: '#FFFFFF',
  Purple: '#6a5166',
  PurpleLight: '#c9b8c6ff',
  Red: '#ff1744',
  RHPurple: '#9973B4',
  RHPurpleLight: '#CDB6CF',
  RHBlack: '#000000',
  RHGray: '#e8e8e8',
  RHBar1: '#735674',
  RHBar2: '#d8cedf',
  RHBar3: '#ad9ac2',
  RHBar4: '#cdafcf',
}

export const Cursor = {
   cursor: 'pointer'
}

export const Error = {
  backgroundColor: '#ffcdd2',
  color: Colors.Red,
  border: '4px solid ' + Colors.Red,
  fontWeight: 'bold'
}

export const Container = {
  video: {
    backgroundColor: Colors.GrayDark
  },
  flexOne: {
    flex: window.innerWidth > 800 ? 1 : 0,
    width: '100%'
  },
  flexTwo: {
    flex: window.innerWidth > 1200 ? 2 : window.innerWidth > 800 ? 1.5 : 0,
    width: '100%'
  },
  flexRow: {
    display: 'flex',
    flexDirection: window.innerWidth > 800 ? 'row' : 'column',
    width: '100%',
    gap: window.innerWidth > 800 ? 20 : 0,
    justifyContent: window.innerWidth > 800 ? 'space-between' : 'flex-start'
  },
  flexRowFixed: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 20,
    justifyContent: 'space-between'
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  flexColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: window.innerWidth > 1200 ? '95%' : '100%'
  },
  center800: {
    width: window.innerWidth > 900 ? 800 : '100%'
  },
  basic: {
    display: 'flex',
    flexDirection: 'column',
    width: window.innerWidth > 1200 ? '36vw' : window.innerWidth > 800 ? '50vw' : '100%'
  },
  basicWide: {
    display: 'flex',
    flexDirection: 'column',
    width: window.innerWidth > 1200 ? '46vw' : window.innerWidth > 800 ? '65vw' : '100%'
  },
  centeredViewport: {
    minHeight: '75vh',
    justifyContent: 'center',
    alignItems: 'center'
  },
  full: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 20,
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  fullMax: {
    display: 'flex',
    flexDirection: window.innerWidth > 800 ? 'row' : 'column',
    width: '100%',
    gap: 20,
    justifyContent: window.innerWidth > 800 ? 'space-between' : 'flex-start',
    marginBottom: 10,
  },
  padding: {
    paddingTop: 20,
    paddingBottom: 20
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center'
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
  },
  center: {
    alignItems: 'center'
  },
  paddingLeft: {
    paddingLeft: 5
  },
  paddingRight: {
    paddingRight: 5
  },
  listColumn: {
    margin: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  listRow: {
    margin: '10px',
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between'
  }
}

export const SubText = {
  fontSize: 14,
  marginBottom: 18,
  letterSpacing: 1.1,
  lineHeight: '1.5em',
  padding: window.innerWidth < 600 ? '0 6px' : '0'
}

export const SubHeadingText = {
  ...SubText,
  marginTop: 8
}

export const SubText2 = {
  fontSize: 12,
  marginBottom: 16,
  letterSpacing: 1.1,
  lineHeight: '1.5em'
}

export const Card = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: Colors.GrayDark,
  borderRadius: 3,
  boxShadow: 'rgba(0, 0, 0, 0.22) 0px 1px 3px, rgba(0, 0, 0, 0.22) 0px 1px 3px',
  boxSizing: 'border-box',
  color: Colors.GrayLight,
  padding: 15
}

export const GrayCard = {
  ...Card,
  backgroundColor: Colors.GrayLight,
  color: Colors.GrayDark,
  Heading: {
    fontWeight: 500,
    fontSize: 12,
    letterSpacing: 1.1,
    textTransform: 'uppercase',
    marginBottom: 6,
    textAlign: 'center'
  },
  SubText: {
    ...SubText,
    textAlign: 'center',
    fontSize: 18,
    marginBottom: 8
  }
}

export const TruCard = {
  ...Card,
  backgroundColor: Colors.GrayLight,
  color: Colors.GrayDark,
  padding: 0,
  
  Header: {
    backgroundColor: Colors.GrayDark,
    color: Colors.White,
    fontWeight: 500,
    fontSize: 12,
    letterSpacing: 1.1,
    textTransform: 'uppercase',
    padding: 10,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
    textAlign: 'center'
  },
  
  Content: {
    border: `1px solid ${Colors.GrayDark}`,
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 3,
    backgroundColor: Colors.White,
    padding: window.innerWidth > 600 ? 15 : 10
  },
  SubText: {
    ...SubText,
    textAlign: 'center',
    fontSize: 15,
    color: Colors.GrayDark,
  },
  SubTextLeft: {
    ...SubText,
    textAlign: 'left',
    fontSize: 15,
    color: Colors.GrayDark,
  }
}

export const Text = {
  note: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    color: Colors.GrayMedium,
    fontSize: 14
  }
}

export const Heading = {
  fontWeight: 500,
  fontSize: 24,
  textTransform: 'uppercase',
  letterSpacing: 1.1,
}

export const SubHeading = {
  ...Heading,
  fontSize: 18,
}

export const SubHeading2 = {
  ...SubHeading,
  textTransform: 'none',
  letterSpacing: 1.6,
  lineHeight: 1.5,
  fontWeight: 300
}

export const Center = {
  textAlign: 'center'
}

export const PaddedContainer = {
  marginTop: 15
}

export const InputContainer = {
  body: {
    marginTop: '10px',
    padding: '6px',
    border: `2px solid ${Colors.GrayVeryLight}`,
    borderRadius: 4
  },
  bodyView: {
    marginTop: '10px',
    padding: '6px',
    border: `2px solid ${Colors.GrayLight}`,
    borderRadius: 4
  },
  container: {
    fontSize: 16,
    fontWeight: 500,
    color: Colors.GrayMedDark,
    margin: '20px'
  },
  row: {
    display: 'flex',
    flexDirection: window.innerWidth > 800 ? 'row' : 'column',
    justifyContent: 'space-between'
  },
  instructions: {
    textAlign: 'center',
    padding: 15,
    fontWeight: 'normal',
    fontSize: 14
  }
}

export const Form = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  // marginTop: 30,
  // marginBottom: 30
}

export const Input = {
  fontSize: 16,
  fontWeight: 'normal',
  border: 'none',
  borderColor: 'transparent',
  height: 40,
  backgroundColor: Colors.GrayLight,
  padding: 0,
  color: Colors.GrayDark,
}

export const Textbox = {
  ...Input,
  padding: 10,
  paddingLeft: 14,
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: 5
}

export const Button = {
  height: 40,
  border: 'none',
  marginLeft: 20,
  paddingLeft: 16,
  paddingRight: 16,
  backgroundColor: Colors.GoldDark,
  color: Colors.GrayDark,
  paddingBlock: 0,
  fontWeight: 500,
  borderRadius: 5,
  textTransform: 'uppercase'
}

export const FullForm = {
  form: {
    ...Form,
    flexDirection: 'column'
  },
  goldBorder: {
    border: 4,
    borderColor: Colors.GoldDark,
    p: 2,
    borderRadius: 1,
    boxSizing: 'border-box' 
  },
  textbox: {
    ...Textbox,
    marginBottom: 30
  },
  name: {
    textTransform: 'capitalize'
  },
  button: {
    ...Button,
    marginLeft: 0,
  }
}

export const Cards = {
  cards: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  card: {
    paddingTop: 10,
    paddingBottom: 10,
    cursor: 'pointer',
    minWidth: 100,
    width: '47%',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

  },
  client: {
    fontWeight: 500,
    fontSize: 14
  },
  clientBusiness: {
    fontSize: 12
  },
  clientDetail: {
    fontSize: 10,
  }
}